import React from "react";

export default function CustomKeywordsComponent({ onInteract, value, data }) {
  return (
    <div onClick={() => onInteract(data)} className="u-display--flex-apart">
      {!!value && value.length ? (
        <React.Fragment>
          <div className="u-overflow-text">{value.join(", ")}</div>
          <div>({value.length})</div>
        </React.Fragment>
      ) : (
        <div>No keywords selected</div>
      )}
    </div>
  );
}
